import React, { ReactNode } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { ReactComponent as FireOutlined } from './menuTagIcons/icon-fire-outlined.svg';
import { ReactComponent as FireFilled } from './menuTagIcons/icon-fire-filled.svg';
import { ReactComponent as ClockOutlined } from './menuTagIcons/icon-clock-outlined.svg';
import { ReactComponent as ClockFilled } from './menuTagIcons/icon-clock-filled.svg';
import { ReactComponent as AvatarOutlined } from './menuTagIcons/icon-avatar-outlined.svg';
import { ReactComponent as AvatarFilled } from './menuTagIcons/icon-avatar-filled.svg';
import { ReactComponent as MyDebatesOutlined } from './menuTagIcons/icon-myDebates-outlined.svg';
import { ReactComponent as MyDebatesFilled } from './menuTagIcons/icon-myDebates-filled.svg';
import { ReactComponent as MyChallengesOutlined } from './menuTagIcons/icon-myChallenges-outlined.svg';
import { ReactComponent as MyChallengesFilled } from './menuTagIcons/icon-myChallenges-filled.svg';
import { ReactComponent as HelpOutlined } from './menuTagIcons/icon-help-outlined.svg';
import { ReactComponent as HelpFilled } from './menuTagIcons/icon-help-filled.svg';
import { ReactComponent as ExitOutlined } from './menuTagIcons/icon-exit-outlined.svg';
import { ReactComponent as ExitFilled } from './menuTagIcons/icon-exit-filled.svg';
import { ReactComponent as IconNetworkGood } from './menuTagIcons/icon-network-good.svg';
import { ReactComponent as IconNetworkNormal } from './menuTagIcons/icon-network-normal.svg';
import { ReactComponent as IconNetworkBad } from './menuTagIcons/icon-network-bad.svg';
import { ReactComponent as IconButtonMore } from './menuTagIcons/icon-button-more.svg';
import { ReactComponent as IconArrowRight } from './сardIcons/icon-arrow-right.svg';
import { ReactComponent as IconArrowLeft } from './сardIcons/icon-arrow-left.svg';
import { ReactComponent as IconUnknownOpponent } from './сardIcons/icon-unknown-opponent.svg';
import { ReactComponent as IconUnknownOpponentFullCard } from './сardIcons/icon-unknown-opponent-full-card.svg';
import { ReactComponent as IconQuestion } from './сardIcons/icon-question.svg';
import { ReactComponent as IconShortArrowRight } from './сardIcons/icon-short-arrow-right.svg';
import { ReactComponent as IconCameraOff } from './zoomIcons/icon-camera_off.svg';
import { ReactComponent as IconCameraOn } from './zoomIcons/icon-camera_on.svg';
import { ReactComponent as IconMicroOff } from './zoomIcons/icon-micro_off.svg';
import { ReactComponent as IconMicroOn } from './zoomIcons/icon-micro_on.svg';
import { ReactComponent as Logo } from './icon_logo.svg';
import { ReactComponent as LogoSmall } from './icon_logo_sm.svg';
import { ReactComponent as Profile } from './mobileMenuIcons/icon-profile.svg';
import { ReactComponent as CreateDebate } from './mobileMenuIcons/icon-create-debate.svg';
import { ReactComponent as MobileDebates } from './mobileMenuIcons/icon-mobile-debates.svg';
import { ReactComponent as MobileDebatesSelected } from './mobileMenuIcons/icon-mobile-debates-selected.svg';
import { ReactComponent as MobileChallenges } from './mobileMenuIcons/icon-mobile-challenges.svg';
import { ReactComponent as MobileChallengesSelected } from './mobileMenuIcons/icon-mobile-challenges-selected.svg';
import { ReactComponent as MobileAbout } from './mobileMenuIcons/icon-mobile-about.svg';
import { ReactComponent as MobileAboutSelected } from './mobileMenuIcons/icon-mobile-about-selected.svg';
import { ReactComponent as CreateWithAI } from './buttonIcons/icon-create-with-AI.svg';
import { ReactComponent as Live } from './menuTagIcons/icon_live.svg';
import { ReactComponent as Discord } from './socialIcons/icon-discord.svg';
import { ReactComponent as Twitter } from './socialIcons/icon-twitter.svg';
import { ReactComponent as ArrowUp } from './buttonIcons/icon-arrow-up.svg';

type IconComponentMapArg = {
  element: ReactNode;
  viewBox?: string;
};

const iconComponentMap: { [key: string]: IconComponentMapArg } = {
  'icon-fire-outlined': { element: FireOutlined, viewBox: '0 0 42 42' },
  'icon-fire-filled': { element: FireFilled, viewBox: '0 0 42 42' },
  'icon-clock-outlined': { element: ClockOutlined, viewBox: '0 0 42 42' },
  'icon-clock-filled': { element: ClockFilled, viewBox: '0 0 42 42' },
  'icon-avatar-outlined': { element: AvatarOutlined, viewBox: '0 0 40 40' },
  'icon-avatar-filled': { element: AvatarFilled, viewBox: '0 0 42 42' },
  'icon-myDebates-outlined': { element: MyDebatesOutlined, viewBox: '0 0 42 42' },
  'icon-myDebates-filled': { element: MyDebatesFilled, viewBox: '0 0 42 42' },
  'icon-myChallenges-outlined': { element: MyChallengesOutlined, viewBox: '0 0 42 42' },
  'icon-myChallenges-filled': { element: MyChallengesFilled, viewBox: '0 0 42 42' },
  'icon-help-outlined': { element: HelpOutlined, viewBox: '0 0 42 42' },
  'icon-help-filled': { element: HelpFilled, viewBox: '0 0 42 42' },
  'icon-exit-outlined': { element: ExitOutlined, viewBox: '0 0 40 40' },
  'icon-exit-filled': { element: ExitFilled, viewBox: '0 0 42 42' },
  'icon-network-good': { element: IconNetworkGood, viewBox: '0 0 16 16' },
  'icon-network-normal': { element: IconNetworkNormal, viewBox: '0 0 16 16' },
  'icon-network-bad': { element: IconNetworkBad, viewBox: '0 0 16 16' },
  'icon-button-more': { element: IconButtonMore, viewBox: '0 0 4 16' },
  'icon-arrow-right': { element: IconArrowRight, viewBox: '0 0 48 24' },
  'icon-arrow-left': { element: IconArrowLeft, viewBox: '0 0 47 24' },
  'icon-unknown-opponent': { element: IconUnknownOpponent, viewBox: '0 0 80 80' },
  'icon-unknown-opponent-full-card': { element: IconUnknownOpponentFullCard, viewBox: '0 0 80 80' },
  'icon-short-arrow-right': { element: IconShortArrowRight, viewBox: '0 0 12 12' },
  'icon-camera_on': { element: IconCameraOn, viewBox: '0 0 28 28' },
  'icon-camera_off': { element: IconCameraOff, viewBox: '0 0 28 28' },
  'icon-micro_off': { element: IconMicroOff, viewBox: '0 0 28 28' },
  'icon-micro_on': { element: IconMicroOn, viewBox: '0 0 28 28' },
  'icon-logo': { element: Logo, viewBox: '0 0 247 36' },
  'icon-logo-sm': { element: LogoSmall, viewBox: '0 0 57 38' },
  'icon-live': { element: Live, viewBox: '0 0 51 28' },
  'icon-mobile-profile': { element: Profile, viewBox: '0 0 27 26' },
  'icon-create-debate': { element: CreateDebate, viewBox: '0 0 45 44' },
  'icon-mobile-debates': { element: MobileDebates, viewBox: '0 0 21 28' },
  'icon-mobile-debates-selected': { element: MobileDebatesSelected, viewBox: '0 0 21 28' },
  'icon-mobile-challenges': { element: MobileChallenges, viewBox: '0 0 26 26' },
  'icon-mobile-challenges-selected': { element: MobileChallengesSelected, viewBox: '0 0 26 26' },
  'icon-mobile-about': { element: MobileAbout, viewBox: '0 0 27 26' },
  'icon-mobile-about-selected': { element: MobileAboutSelected, viewBox: '0 0 27 26' },
  'icon-create-with-AI': { element: CreateWithAI, viewBox: '0 0 24 24' },
  'icon-discord': { element: Discord, viewBox: '0 0 44 44' },
  'icon-twitter': { element: Twitter, viewBox: '0 0 44 44' },
  'icon-arrow-up': { element: ArrowUp, viewBox: '0 0 30 30' },
  'icon-question': { element: IconQuestion, viewBox: '0 0 24 24' },
};

interface CustomMuiIconProps extends SvgIconProps {
  type: string;
  size?: string;
}

export const CustomMuiIcon: React.FunctionComponent<CustomMuiIconProps> = ({
  type,
  sx,
  size,
  ...props
}) => {
  const component = iconComponentMap[type];
  return component ? (
    <SvgIcon
      component={component.element}
      {...props}
      viewBox={component.viewBox}
      sx={{ fontSize: size || undefined, ...sx }}
    />
  ) : null;
};
